import * as React from 'react';

import { DiagramTransaction } from 'src/containers/ProjectDiagram/constants/transactions';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { useTooltip } from 'src/containers/ProjectDiagram/hooks/useTooltipValue';
import { commitDiagramWhileSkippingUndoManager } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { setDiagramHighlight } from 'src/containers/ProjectDiagram/utils/setDiagramHighlight';
import { setDiagramSelection } from 'src/containers/ProjectDiagram/utils/setDiagramSelection';

export const useClearDiagram = () => {
  const [, setTooltip] = useTooltip();
  const diagram = useDiagram();

  return React.useCallback(() => {
    if (!diagram) {
      return;
    }

    setTooltip(null);

    commitDiagramWhileSkippingUndoManager(
      diagram,
      (_, diagram) => {
        setDiagramHighlight()(diagram);
        setDiagramSelection()(diagram);
      },
      DiagramTransaction.CLEAR_DIAGRAM
    );
  }, [diagram, setTooltip]);
};
